(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var stored = sessionStorage.getItem('airvy-offer-end');
    var end;
    if (stored) {
      end = parseInt(stored, 10);
    } else {
      var d = new Date();
      d.setHours(23, 59, 59, 0);
      if (Date.now() >= d.getTime()) d.setDate(d.getDate() + 1);
      end = d.getTime();
      sessionStorage.setItem('airvy-offer-end', end);
    }
    function tick() {
      var diff = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var h = Math.floor(diff / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;
      var pad = function(n) { return String(n).padStart(2, '0'); };
      var elH = document.getElementById('ann-cd-h');
      var elM = document.getElementById('ann-cd-m');
      var elS = document.getElementById('ann-cd-s');
      if (elH) elH.textContent = pad(h);
      if (elM) elM.textContent = pad(m);
      if (elS) elS.textContent = pad(s);
      if (diff > 0) setTimeout(tick, 1000);
    }
    tick();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["attachments-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.airvy-scope .animate').forEach(function(el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coanda-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.airvy-coanda .animate, .airvy-coanda .animate-scale').forEach(function(el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.ac-card__atc-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.ac-card__atc');
        var id = form.querySelector('[name="id"]').value;
        var orig = btn.textContent;
        btn.disabled = true;
        btn.textContent = '…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
        })
          .then(function () {
            btn.textContent = '✓ Hinzugefügt';
            document.dispatchEvent(new CustomEvent('airvy:cart-added'));
            setTimeout(function () {
              btn.textContent = orig;
              btn.disabled = false;
            }, 2000);
          })
          .catch(function () {
            btn.textContent = orig;
            btn.disabled = false;
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.airvy-cta-banner .animate').forEach(function(el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.getElementById('airvy-header');
    var burger = document.querySelector('[data-burger]');
    var menu   = document.querySelector('[data-mobile-menu]');

    function updateHeader() {
      if (window.scrollY > 10) {
        header.classList.add('airvy-header--solid');
      } else {
        header.classList.remove('airvy-header--solid');
      }
    }
    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();

    if (!burger || !menu) return;

    function closeMenu() {
      menu.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
    }

    burger.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    });

    document.querySelectorAll('[data-mobile-nav]').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    /* Smooth scroll for same-page anchor links */
    document.querySelectorAll('[data-scroll-link]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        var hash = href.indexOf('#') !== -1 ? href.split('#')[1] : null;
        if (!hash) return;
        var target = document.getElementById(hash);
        if (!target) return;
        e.preventDefault();
        closeMenu();
        var headerH = header ? header.getBoundingClientRect().height : 68;
        var top = target.getBoundingClientRect().top + window.scrollY - headerH - 8;
        window.scrollTo({ top: top, behavior: 'smooth' });
        history.pushState(null, '', '#' + hash);
      });
    });

    /* Handle initial hash on page load */
    if (window.location.hash) {
      var initHash = window.location.hash.slice(1);
      var initTarget = document.getElementById(initHash);
      if (initTarget) {
        setTimeout(function () {
          var headerH = header ? header.getBoundingClientRect().height : 68;
          var top = initTarget.getBoundingClientRect().top + window.scrollY - headerH - 8;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }, 120);
      }
    }

    /* Cart Drawer */
    var cartDrawer  = document.getElementById('airvy-cart-drawer');
    var cartOverlay = document.getElementById('airvy-cart-overlay');
    var cartClose   = document.getElementById('airvy-cart-close');
    var cartBody    = document.getElementById('airvy-cart-body');
    var cartFoot    = document.getElementById('airvy-cart-foot');
    var cartCountEl = document.getElementById('airvy-cart-count');
    var cartTrigger = document.getElementById('airvy-cart-trigger');
    var headerBadge = document.getElementById('airvy-header-badge');

    /* Cart Timer */
    var TIMER_KEY = 'airvy_cart_timer_end';
    var timerInterval = null;

    function startCartTimer() {
      var timerEl = document.getElementById('airvy-cart-timer');
      if (!timerEl) return;
      clearInterval(timerInterval);
      var endTime = parseInt(sessionStorage.getItem(TIMER_KEY) || '0', 10);
      if (!endTime || endTime <= Date.now()) {
        endTime = Date.now() + 5 * 60 * 1000;
        sessionStorage.setItem(TIMER_KEY, endTime);
      }
      function tick() {
        var remaining = Math.max(0, endTime - Date.now());
        var mins = Math.floor(remaining / 60000);
        var secs = Math.floor((remaining % 60000) / 1000);
        timerEl.textContent = String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
        if (remaining <= 0) {
          endTime = Date.now() + 5 * 60 * 1000;
          sessionStorage.setItem(TIMER_KEY, endTime);
        }
      }
      tick();
      timerInterval = setInterval(tick, 1000);
    }

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function openCartDrawer() {
      if (!cartDrawer) return;
      cartDrawer.classList.add('is-open');
      if (cartOverlay) cartOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      cartDrawer.setAttribute('aria-hidden', 'false');
      startCartTimer();
    }

    function closeCartDrawer() {
      if (!cartDrawer) return;
      cartDrawer.classList.remove('is-open');
      if (cartOverlay) cartOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
      cartDrawer.setAttribute('aria-hidden', 'true');
      clearInterval(timerInterval);
    }

    function updateBadge(count) {
      if (!headerBadge) return;
      headerBadge.textContent = count;
      headerBadge.style.display = count > 0 ? 'flex' : 'none';
    }



    function renderCart(cart) {
      updateBadge(cart.item_count);
      if (cartCountEl) cartCountEl.textContent = cart.item_count;
      startCartTimer();

      if (!cartBody) return;

      if (cart.item_count === 0) {
        cartBody.innerHTML = '<div class="airvy-cart-empty"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg><p class="airvy-cart-empty__text">Dein Warenkorb ist leer</p><a href="/products/airvy-lumis" class="airvy-cart-empty__link">Jetzt shoppen →</a></div>';
        if (cartFoot) cartFoot.style.display = 'none';
        return;
      }

      var html = '';
      cart.items.forEach(function(item, idx) {
        var line = idx + 1; /* 1-based line number */
        var qty  = item.quantity;
        var imgSrc = item.image ? item.image.replace(/_([\d]+)x([\d]+)/, '_200x200') : '';
        html += '<div class="airvy-cart-item">';
        html += '<div class="airvy-cart-item__img">' + (imgSrc ? '<img src="' + imgSrc + '" alt="" loading="lazy">' : '') + '</div>';
        html += '<div class="airvy-cart-item__info">';
        html += '<span class="airvy-cart-item__title">' + item.product_title + '</span>';
        html += '<span class="airvy-cart-item__price">' + formatMoney(item.final_line_price) + '</span>';
        html += '<div class="airvy-cart-item__qty">';
        html += '<button class="airvy-cart-item__qty-btn" data-line="' + line + '" data-delta="-1" data-qty="' + qty + '" aria-label="Weniger">−</button>';
        html += '<span class="airvy-cart-item__qty-num">' + qty + '</span>';
        html += '<button class="airvy-cart-item__qty-btn" data-line="' + line + '" data-delta="1" data-qty="' + qty + '" aria-label="Mehr">+</button>';
        html += '<button class="airvy-cart-item__remove" data-line="' + line + '">Entfernen</button>';
        html += '</div></div></div>';
      });
      cartBody.innerHTML = html;

      if (cartFoot) {
        cartFoot.style.display = 'flex';
        var subtotalEl = document.getElementById('airvy-cart-subtotal');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      }

      /* Gratis-Geschenke – nur für bekannte Produkte, nicht global */
      var PRODUCT_GIFTS = {
        'airvy-lumis': [
          { name: '5 Styling-Aufsätze im Set',     cents: 5499 },
          { name: '2 Lockenstäbe',                  cents: 2999 },
          { name: 'Kostenloser DHL-Versand',        cents: 499  }
        ]
      };
      var giftItems = cart.items.filter(function(i) { return PRODUCT_GIFTS[i.handle]; });
      if (giftItems.length > 0) {
        var totalQty = giftItems.reduce(function(s, i) { return s + i.quantity; }, 0);
        var productSavings = cart.items.reduce(function(s, i) {
          return s + Math.max(0, (i.original_line_price || 0) - (i.final_line_price || 0));
        }, 0);
        var GIFTS = PRODUCT_GIFTS[giftItems[0].handle];
        var giftTotal = GIFTS.reduce(function(s, g) { return s + g.cents; }, 0) * totalQty;
        var totalSavings = giftTotal + productSavings;
        var chk = '<svg width="11" height="11" viewBox="0 0 24 24" fill="#C9A84C"><path d="M20 6L9 17l-5-5"/></svg>';
        var giftGiftIcon = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 12v10H4V12"/><path d="M22 7H2v5h20V7z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/></svg>';
        var g = '<div class="airvy-cart-gifts"><div class="airvy-cart-gifts__header">' + giftGiftIcon + 'DEINE GRATIS GESCHENKE</div><ul class="airvy-cart-gifts__list">';
        GIFTS.forEach(function(gift) {
          g += '<li>' + chk + '<span>' + gift.name + '</span><s>' + formatMoney(gift.cents) + '</s></li>';
        });
        g += '</ul><div class="airvy-cart-gifts__savings"><span>Du sparst insgesamt</span><span class="airvy-cart-gifts__amount">–' + formatMoney(totalSavings) + '</span></div></div>';
        cartBody.insertAdjacentHTML('beforeend', g);
      }

      cartBody.querySelectorAll('.airvy-cart-item__qty-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          btn.disabled = true;
          var newQty = Math.max(0, parseInt(btn.dataset.qty, 10) + parseInt(btn.dataset.delta, 10));
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: parseInt(btn.dataset.line, 10), quantity: newQty })
          }).then(function(r) { return r.json(); }).then(renderCart);
        });
      });

      cartBody.querySelectorAll('.airvy-cart-item__remove').forEach(function(btn) {
        btn.addEventListener('click', function() {
          btn.textContent = '…';
          btn.disabled = true;
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: parseInt(btn.dataset.line, 10), quantity: 0 })
          }).then(function(r) { return r.json(); }).then(renderCart);
        });
      });
    }

    function fetchCart() {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(renderCart);
    }

    if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

    if (cartTrigger) {
      cartTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        fetchCart();
        openCartDrawer();
      });
    }

    document.addEventListener('airvy:cart-added', function() {
      fetchCart();
      openCartDrawer();
    });

    fetchCart();

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.airvy-hfaq__item');
        var answer = item.querySelector('.airvy-hfaq__a');
        var isOpen = item.classList.contains('is-open');
        document.querySelectorAll('.airvy-hfaq__item.is-open').forEach(function (open) {
          open.classList.remove('is-open');
          open.querySelector('.airvy-hfaq__a').hidden = true;
          open.querySelector('[data-faq-q]').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          answer.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.airvy-hfaq .animate').forEach(function (el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-features"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.airvy-feat .animate').forEach(function(el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kontakt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.airvy-kt .animate').forEach(function (el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  (function () {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.airvy-page .animate').forEach(function(el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-tab-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var subnav   = document.getElementById('airvy-pdp-subnav');
    if (!subnav) return;

    var hero     = document.getElementById('atc-section');
    var header   = document.getElementById('airvy-header');
    var tabsEl   = document.getElementById('pdp-subnav-tabs');
    var trackWrap = document.getElementById('pdp-track-wrap');
    var prevBtn  = document.getElementById('pdp-tabs-prev');
    var nextBtn  = document.getElementById('pdp-tabs-next');
    var topBtn   = document.getElementById('pdp-subnav-top-btn');
    var tabs     = document.querySelectorAll('[data-pdp-section]');
    var NAV_H    = 52;

    /* ── Show / hide subnav + swap with header ── */
    var wasVisible = false;

    function onScroll() {
      if (!hero) return;
      var heroBottom = hero.getBoundingClientRect().bottom;
      var shouldShow = heroBottom < 4;

      subnav.classList.toggle('is-visible', shouldShow);
      subnav.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      if (header) header.classList.toggle('pdp-nav-active', shouldShow);

      if (shouldShow) {
        if (!wasVisible && tabsEl) {
          /* first appearance: reset strip to left so Aufsätze is always visible */
          tabsEl.scrollLeft = 0;
          setTimeout(updateArrows, 50);
        }
        updateActive();
      }
      wasVisible = shouldShow;
    }

    /* ── Arrow visibility + edge gradients ── */
    function updateArrows() {
      if (!tabsEl || !trackWrap) return;
      var sl = tabsEl.scrollLeft;
      var max = tabsEl.scrollWidth - tabsEl.clientWidth;

      var hasLeft  = sl > 4;
      var hasRight = sl < max - 4;

      if (prevBtn) prevBtn.classList.toggle('is-visible', hasLeft);
      if (nextBtn) nextBtn.classList.toggle('is-visible', hasRight);
      trackWrap.classList.toggle('has-left',  hasLeft);
      trackWrap.classList.toggle('has-right', hasRight);
    }

    if (tabsEl) {
      tabsEl.addEventListener('scroll', updateArrows, { passive: true });
      /* Run once after fonts/layout settle */
      setTimeout(updateArrows, 200);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        tabsEl.scrollBy({ left: -120, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        tabsEl.scrollBy({ left: 120, behavior: 'smooth' });
      });
    }

    /* ── Active tab tracking ── */
    var sections = [];
    tabs.forEach(function (tab) {
      var el = document.getElementById(tab.dataset.pdpSection);
      if (el) sections.push({ el: el, tab: tab });
    });

    function docTop(el) {
      /* accurate distance from document top, regardless of positioned ancestors */
      return el.getBoundingClientRect().top + window.scrollY;
    }

    function updateActive() {
      var viewTop = window.scrollY + NAV_H + 32;
      var current = null;
      sections.forEach(function (s) {
        if (docTop(s.el) <= viewTop) current = s;
      });
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      if (current) {
        current.tab.classList.add('is-active');
        /* only scroll the tab strip if active tab is outside visible range */
        if (tabsEl) {
          var tabRect  = current.tab.getBoundingClientRect();
          var wrapRect = tabsEl.getBoundingClientRect();
          if (tabRect.left < wrapRect.left || tabRect.right > wrapRect.right) {
            current.tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        }
        updateArrows();
      }
    }

    /* ── Smooth scroll on tab click ── */
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        var target = document.getElementById(tab.dataset.pdpSection);
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.scrollY - (NAV_H + 8);
        window.scrollTo({ top: top, behavior: 'smooth' });
        history.pushState(null, '', '#' + tab.dataset.pdpSection);
      });
    });

    /* ── Back-to-top button ── */
    if (topBtn) {
      topBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-attachments"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var track = document.getElementById('att-track');
    var prev  = document.getElementById('att-prev');
    var next  = document.getElementById('att-next');
    if (!track) return;

    function cardStep() {
      var card = track.querySelector('.airvy-att__card');
      return card ? card.offsetWidth + 20 : 220;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: cardStep(), behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.airvy-ba__slider').forEach(function (slider) {
      var input = slider.querySelector('.airvy-ba__range');
      if (!input) return;
      input.addEventListener('input', function () {
        slider.style.setProperty('--split', input.value + '%');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrap = document.getElementById('compare-table-wrap');
    var hint = document.getElementById('compare-scroll-hint');
    if (!wrap || !hint) return;
    if (wrap.scrollWidth > wrap.clientWidth + 4) {
      hint.classList.add('is-visible');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-faq-question]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.airvy-pdp-faq__item');
        item.classList.toggle('open');
      });
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (el) {
        if (el.isIntersecting) el.target.classList.add('visible');
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.airvy-pdp-faq .animate').forEach(function (el) {
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (el) {
        if (el.isIntersecting) el.target.classList.add('visible');
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.airvy-pdp-features .animate').forEach(function (el) {
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Gallery */
    var mainEl = document.getElementById('airvy-gallery-main');
    var slides = document.querySelectorAll('[data-slide]');
    var thumbs = document.querySelectorAll('.airvy-pdp__thumb');
    var currentIdx = 0;
    var captionsData = document.getElementById('airvy-captions-json');
    var captions = captionsData ? JSON.parse(captionsData.textContent) : [];
    var captionEl = document.getElementById('airvy-caption-text');

    function switchTo(idx) {
      if (idx < 0) idx = slides.length - 1;
      if (idx >= slides.length) idx = 0;
      currentIdx = idx;
      slides.forEach(function(s) { s.classList.remove('active'); });
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      var ts = document.querySelector('[data-slide="' + idx + '"]');
      var tt = document.querySelector('.airvy-pdp__thumb[data-index="' + idx + '"]');
      if (ts) ts.classList.add('active');
      if (tt) tt.classList.add('active');
      if (captionEl && captions[idx] !== undefined) {
        captionEl.style.opacity = '0';
        setTimeout(function() {
          captionEl.textContent = captions[idx];
          captionEl.style.opacity = '1';
        }, 180);
      }
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        switchTo(parseInt(thumb.dataset.index, 10));
      });
    });

    var prevBtn = document.getElementById('airvy-nav-prev');
    var nextBtn = document.getElementById('airvy-nav-next');
    if (prevBtn) prevBtn.addEventListener('click', function() { switchTo(currentIdx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { switchTo(currentIdx + 1); });

    /* Touch swipe */
    if (mainEl && slides.length > 1) {
      var touchStartX = 0;
      mainEl.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      mainEl.addEventListener('touchend', function(e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) switchTo(currentIdx + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    /* Variant picker */
    var variantInput = document.querySelector('[data-pdp-variant-input]');
    var selectedName = document.querySelector('[data-pdp-selected-name]');
    var priceEl      = document.querySelector('[data-pdp-price]');
    var atcBtn       = document.getElementById('airvy-atc-btn');

    document.querySelectorAll('[data-pdp-swatch]').forEach(function(sw) {
      sw.addEventListener('click', function() {
        var available = sw.dataset.variantAvailable === 'true';
        if (variantInput) variantInput.value = sw.dataset.variantId;
        if (selectedName) selectedName.textContent = sw.dataset.variantName;
        if (priceEl) priceEl.textContent = sw.dataset.variantPrice;
        if (atcBtn) {
          atcBtn.disabled = !available;
          if (available) {
            atcBtn.innerHTML = atcBtn.innerHTML.replace(/[€\d,\.]+(?:\s*€[€\d,\.]+)?$/, sw.dataset.variantPrice);
          }
        }
        /* Update sticky ATC price */
        var stickyPrice = document.getElementById('airvy-sticky-price');
        if (stickyPrice) stickyPrice.textContent = sw.dataset.variantPrice;
        document.querySelectorAll('[data-pdp-swatch]').forEach(function(s) { s.classList.remove('active'); });
        sw.classList.add('active');
        var url = new URL(window.location.href);
        url.searchParams.set('variant', sw.dataset.variantId);
        window.history.replaceState({}, '', url.toString());
      });
    });

    /* Qty stepper */
    var qtyInput = document.getElementById('airvy-qty-input');
    if (qtyInput) {
      document.querySelectorAll('[data-qty]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var val = parseInt(qtyInput.value, 10) || 1;
          if (btn.dataset.qty === 'plus') val = Math.min(99, val + 1);
          if (btn.dataset.qty === 'minus') val = Math.max(1, val - 1);
          qtyInput.value = val;
        });
      });
    }

    /* ATC Form → open cart drawer */
    var atcForm = document.getElementById('airvy-product-form');
    if (atcForm) {
      atcForm.addEventListener('submit', function(e) {
        e.preventDefault();
        if (!variantInput || !variantInput.value) return;
        var origHTML = atcBtn ? atcBtn.innerHTML : '';
        if (atcBtn) { atcBtn.disabled = true; atcBtn.innerHTML = '<span style="font-size:1.4em;letter-spacing:0">…</span>'; }
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantInput.value, 10), quantity: qty })
        })
          .then(function(r) { return r.json(); })
          .then(function() {
            if (atcBtn) { atcBtn.disabled = false; atcBtn.innerHTML = origHTML; }
            document.dispatchEvent(new CustomEvent('airvy:cart-added'));
          })
          .catch(function() {
            if (atcBtn) { atcBtn.disabled = false; atcBtn.innerHTML = origHTML; }
          });
      });
    }

    /* Countdown timer – shared with announcement bar via sessionStorage */
    var timerEl = document.getElementById('airvy-countdown');
    if (timerEl) {
      var stored = sessionStorage.getItem('airvy-offer-end');
      var endTime;
      if (stored) {
        endTime = parseInt(stored, 10);
      } else {
        var d = new Date();
        d.setHours(23, 59, 59, 0);
        if (Date.now() >= d.getTime()) d.setDate(d.getDate() + 1);
        endTime = d.getTime();
        sessionStorage.setItem('airvy-offer-end', endTime);
      }
      function updateTimer() {
        var diff = Math.max(0, endTime - Date.now());
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        timerEl.textContent =
          String(h).padStart(2, '0') + ':' +
          String(m).padStart(2, '0') + ':' +
          String(s).padStart(2, '0');
      }
      updateTimer();
      setInterval(updateTimer, 1000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (el) {
        if (el.isIntersecting) el.target.classList.add('visible');
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.airvy-pdp-reviews .animate').forEach(function (el) {
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.getElementById('airvy-sticky-bar');
    var stickyBtn = document.getElementById('airvy-sticky-btn');
    var mainBtn = document.getElementById('airvy-atc-btn');

    if (!bar || !mainBtn) return;

    var hasBeenVisible = false;

    var obs = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      if (visible) hasBeenVisible = true;
      if (hasBeenVisible) {
        bar.classList.toggle('airvy-sticky--visible', !visible);
        bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      }
    }, { threshold: 0 });

    obs.observe(mainBtn);

    if (!stickyBtn) return;

    stickyBtn.addEventListener('click', function () {
      var variantInput = document.querySelector('[data-pdp-variant-input]');
      if (!variantInput || !variantInput.value) return;

      var originalText = stickyBtn.textContent;
      stickyBtn.disabled = true;
      stickyBtn.textContent = '…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantInput.value, 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          stickyBtn.disabled = false;
          stickyBtn.textContent = originalText;
          document.dispatchEvent(new CustomEvent('airvy:cart-added'));
        })
        .catch(function () {
          stickyBtn.disabled = false;
          stickyBtn.textContent = originalText;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
